// extracted by mini-css-extract-plugin
export default {"myCardAddres":"styles_myCardAddres__PcK-H","containerCreate":"styles_containerCreate__-jp-l"};